<template>
  <div class="view content">
    <div class="container content">
      <div class="main-title">
        Informations fournies à l'Utilisateur au titre de ses données à caractère personnel (règlement UE 2016/679 du 27 avril 2016 (RGPD) et loi n°78-17 du 6
        janvier 1978)
      </div>
      <div class="title">PRÉAMBULE</div>
      <div class="paragraph">
        Dans le cadre de la commande et/ou l'usage par l'Utilisateur de prestations, services ou Documents auprès d'Infogreffe et via le Site, l'Utilisateur,
        après que son consentement ait été recueilli à cet effet, et dans le respect des stipulations ci-après, voit ses données à caractère personnel être
        collectées par Infogreffe.
      </div>
      <div class="title">LES DONNÉES À CARACTÈRE PERSONNEL OBJETS D'UNE COLLECTE</div>
      <div class="paragraph">
        Les données à caractère personnel collectées sont les suivantes : (i) les informations que fournit l'Utilisateur en remplissant les formulaires relatifs
        à la création de son compte et/ou relatifs à ses commandes et/ou relatifs à son identification, ou en communiquant avec Infogreffe (par tout moyen de
        communication ou de communication en ligne, ou en répondant à des questionnaires ou enquêtes de satisfaction) (ii) ce qui concerne notamment le nom,
        genre, date et lieu de naissance de l'Utilisateur, ainsi que les coordonnées de l'Utilisateur telles que son adresse postale, son adresse de messagerie
        électronique, numéros de téléphone, signature électronique, données de la carte nationale d'identité (iii) ainsi que notamment les informations
        relatives à la relation contractuelle et commerciale entre l'Utilisateur et Infogreffe (notamment les détails des produits, services et/ou Documents
        commandés par l'Utilisateur) (iv) et les informations bancaires (coordonnées bancaires, numéros de carte) et transactionnelles de l'Utilisateur (v)
        ainsi que les données recueillies grâce aux cookies et technologies similaires utilisés sur le Site (notamment adresses IP) et dans les messages
        électroniques permettant de reconnaître l'Utilisateur, se souvenir de ses préférences et, le cas échéant, de lui présenter un contenu susceptible de
        l'intéresser.
        <RouterLink :to="{ name: 'cookies' }" class="link"
          >En savoir plus sur les informations relatives à notre politique d'utilisation des cookies
        </RouterLink>
        <br />
        <br />Ces données personnelles ne peuvent être communiquées à Infogreffe que par les Utilisateurs concernés par les dites données à caractère personnel
        et chaque Utilisateur s'interdit de communiquer des données à caractère personnel d'une autre personne et/ou des données à caractère personnel qui ne le
        concernent pas.
      </div>
      <div class="title">INFORMATIONS LÉGALES À DESTINATION DE L'UTILISATEUR</div>
      <div class="paragraph">
        Les présentes ont notamment pour objet de donner à l'Utilisateur les informations légales requises, lesquelles informations sont les suivantes (lesdites
        informations étant également notifiées à l'Utilisateur avant que ses données à caractère personnel ne soient collectées, et ce séparément de toutes
        autres informations, conformément aux dispositions en vigueur) :
      </div>
      <div class="subtitle">(a) Identité et coordonnées du responsable du traitement de données à caractère personnel (ci-après le « traitement »)</div>
      <div class="paragraph">
        L'identité et les coordonnées du responsable du traitement de données à caractère personnel sont les suivantes : le G.I.E. INFOGREFFE, Groupement
        d'intérêt économique (de nature civile), immatriculé au registre du commerce et des sociétés de Créteil sous le numéro 338 885 718 et dont le siège
        social est situé 5-7 Avenue de Paris, 94 300 Vincennes.
      </div>
      <div class="subtitle">(b) Coordonnées du délégué à la protection des données</div>
      <div class="paragraph">
        Pour toute question relative au traitement des données à caractère personnel, les Utilisateurs peuvent contacter Infogreffe à l’adresse suivante :
        Infogreffe à l’attention du Délégué à la protection des données, 5-7 Avenue de Paris, 94300 Vincennes.<br />
        <br />Les demandes des Utilisateurs relatives au traitement des données à caractère personnel peuvent également être adressées par mail à l’adresse
        suivante :
        <a
          class="link"
          href="mailto:protection-donnees@infogreffe-siege.protection-donnees@infogreffe-siege.fr
        "
          >protection-donnees@infogreffe-siege.fr</a
        >.<br />
        <br />Le Délégué à la protection des données, est le cabinet d’avocats AARPI VIRTUALEGIS, situé 5 rue Jean-Baptiste Dumas, 75017 Paris.
      </div>
      <div class="subtitle">(c) Finalités du traitement</div>
      <div class="paragraph">
        Les finalités du traitement auquel sont destinées les données à caractère personnel sont les suivantes : (i) identification des personnes commandant
        et/ou utilisant des Documents via le Site et/ou des services ou prestations accessibles via le Site (ii) réalisation et/ou livraison par Infogreffe des
        Documents et/ou prestations utilisés et/ou commandés par l'Utilisateur (iii) administration des prestations et/ou Documents commandés et/ou utilisés par
        l'Utilisateur (iv) prospection et/ou envoi d'informations aux Utilisateurs.
      </div>
      <div class="subtitle">(d) Base juridique du traitement</div>
      <div class="paragraph">
        La base juridique du traitement est le suivant : (i) le traitement est nécessaire à l'exécution de la relation contractuelle que l'Utilisateur souhaite
        nouer avec Infogreffe en lui commandant et/ou en utilisant des services et/ou prestations et/ou des Documents, les dites données à caractère personnel
        étant nécessaires à la réalisation des prestations et/ou services commandés par l'Utilisateur (ii) le traitement est également nécessaire à protéger les
        intérêts légitimes d'Infogreffe en lui permettant de conserver la preuve des transactions avec l'Utilisateur et/ou le cas échéant procéder au
        recouvrement (iii) le traitement repose sur le consentement de l'Utilisateur souhaitant commander et/ou utiliser des Documents et/ou prestations et/ou
        services via le Site (iv) le traitement étant administré conformément aux dispositions de la loi n°78-17 du 6 janvier 1978 et du règlement UE 2016/679
        du 27 avril 2016 (RGPD) et des autres dispositions légales en vigueur (ci-après la « Réglementation en vigueur »).
      </div>
      <div class="subtitle">(e) Destinataires des données à caractère personnel</div>
      <div class="paragraph">
        Les destinataires des données à caractère personnel sont : les personnels d'Infogreffe en charge de la réalisation et/ou l'administration des
        prestations et/ou Documents commandés et/ou utilisés par l'Utilisateur, la réalisation et/ou la livraison par Infogreffe des Documents et/ou prestations
        et/ou services commandés et/ou utilisés par l'Utilisateur et, le cas échéant, les prestataires sous-traitants d'Infogreffe participant à la réalisation
        de ces missions et étant amené à intervenir à ce titre sur les traitements (uniquement lorsque cela est nécessaire), étant alors précisé qu'en pareille
        hypothèse cela est effectué dans le respect de la Réglementation en vigueur applicable aux sous-traitants.
      </div>
      <div class="subtitle">(f) Transfert des données à caractère personnel</div>
      <div class="paragraph">
        L'Utilisateur est informé que le responsable du traitement peut, le cas échéant, effectuer un transfert de ses données à caractère personnel vers un
        pays tiers ou à une organisation internationale faisant l'objet d'une décision d'adéquation rendue par la commission européenne étant précisé que, en
        présence d'un transfert vers un pays ou une organisation internationale ne faisant pas l'objet d'une décision d'adéquation, alors cela ne pourra être
        effectué qu'à la condition que soient mises en place les garanties appropriées et que les Utilisateurs concernés disposent de droits opposables et de
        voies de recours effectives, dans les conditions de la Réglementation en vigueur.
      </div>
      <div class="subtitle">(g) Durée de conservation des données à caractère personnel :</div>
      <div class="paragraph">
        La durée de conservation des données à caractère personnel est la suivante : les données personnelles étant nécessaires à la réalisation, administration
        et/ou livraison des prestations et/ou commandes réalisées via le Site, les données à caractère personnel de l'Utilisateur sont conservées (i) tant que
        l'Utilisateur est susceptible de pouvoir passer des commandes, c'est-à-dire tant que l'Utilisateur n'a pas manifesté son intention de ne plus être un
        client d'Infogreffe ou de ne plus voir conservées ses données personnelles, et ce via une demande effectuée par ses soins adressée à l'adresse suivante
        :
        <a href="mailto:protection-donnees@infogreffe-siege.fr" class="link">protection-donnees@infogreffe-siege.fr</a>
        (conformément aux stipulations ci-après) (ii) dans la limite toutefois d'une durée de 36 (trente-six) mois à compter de la dernière commande de
        prestations et/ou Documents effectuée par l'Utilisateur via le Site, date aux termes de laquelle les données à caractère personnel ne sont plus
        conservées.
      </div>
      <div class="subtitle">(h) Droits de l'Utilisateur pouvant être exercés auprès du responsable du traitement (tel qu'identifié ci-avant)</div>
      <div class="paragraph">
        Les présentes ont également pour objet d'informer l'Utilisateur de l'existence de son droit de demander au responsable du traitement (tel qu'identifié
        ci-avant) :
        <ul>
          <li>l'accès à ses données à caractère personnel ainsi que toute information disponible quant à leur source ;</li>
          <li>la rectification ou l'effacement de celles-ci ;</li>
          <li>une limitation du traitement de ses données à caractère personnel</li>
          <li>l'opposition de l'Utilisateur au traitement de ses données à caractère personnel ;</li>
          <li>
            l'opposition de l'Utilisateur à tout moment au traitement de ses données à caractère personnel à des fins de prospection, y compris au profilage ;
          </li>
          <li>
            la portabilité de ses données à caractère personnel dans les conditions de la Réglementation en vigueur laquelle dispose notamment que les personnes
            concernées par un traitement de données à caractère personnel ont le droit de recevoir les données à caractère personnel les concernant qu'elles ont
            fournies à un responsable du traitement, dans un format structuré, couramment utilisé et lisible par machine, et ont le droit de transmettre ces
            données à un autre responsable du traitement sans que le responsable du traitement auquel les données à caractère personnel ont été communiquées y
            fasse obstacle, lorsque: (i) le traitement est fondé sur le consentement en application de la Réglementation en Vigueur, ou sur un contrat en
            application de la Réglementation en vigueur et (ii) lorsque le traitement est effectué à l'aide de procédés automatisés, étant précisé que lorsque
            la personne concernée exerce son droit à la portabilité de ses données à caractère personnel, elle a le droit d'obtenir que ses données à caractère
            personnel soient transmises directement d'un responsable du traitement à un autre, lorsque cela est techniquement possible.
          </li>
          <li>
            Le retrait par l'Utilisateur, à tout moment, de son consentement au traitement de ses données à caractère personnel (sans porter atteinte à la
            licéité du traitement fondé sur le consentement effectué avant le retrait de celui-ci) ;
          </li>
        </ul>
        L'exercice par l'Utilisateur de ses droits tels qu'identifiés au présent (h) est réalisé au moyen d'une demande effectuée par ses soins et adressée à
        l'adresse suivante :
        <a href="mailto:protection-donnees@infogreffe-siege.fr" class="link">protection-donnees@infogreffe-siege.fr</a>
        <br />
        <br />En tant que de besoin, il est stipulé que, l'exercice par un Utilisateur de son droit à l'effacement de ses données à caractère personnel et/ou
        l'exercice de son droit de s'opposer au traitement de ses données à caractère personnel et/ou l'exercice de son droit à une limitation du traitement de
        ses données à caractère personnel et/ou de son droit de retirer son consentement à tout moment au traitement de ses données à caractère personnel
        (conformément aux stipulations susvisées) conduit à ne pas rendre possible la livraison des prestations et/ou Documents commandés et/ou utilisés par
        l'Utilisateur et, plus globalement, à ne pas rendre possible la réalisation des prestations commandées et/ou utilisées, de sorte que, en pareilles
        hypothèses (i) à compter de l'exercice par l'Utilisateur des dits droits, celui-ci ne pourra plus accéder aux services et prestations délivrés par
        Infogreffe via le Site (ii) si ces droits sont exercés au moment de la commande de prestations ou services ou Documents, alors la dite commande ne
        pourra être effectuée par l'Utilisateur (iii) et, si l'Utilisateur est titulaire d'un contrat d'abonnement, le compte de ce dernier récipiendaire de ses
        données à caractère personnel sera supprimé.
      </div>
      <div class="subtitle">(i) Réclamation auprès de la CNIL</div>
      <div class="paragraph">
        L'Utilisateur est informé du droit d'introduire une réclamation auprès de l'autorité de contrôle laquelle est la Commission Nationale de L'Informatique
        et des Libertés (CNIL) : 3 Place de Fontenoy - TSA 80715 - 75334 Paris 07.
      </div>
      <div class="subtitle">(j) Informations sur le caractère contractuel de la fourniture des données à caractère personnel</div>
      <div class="paragraph">
        Au titre de la fourniture à l'Utilisateur des informations sur la question de savoir si l'exigence de fourniture de données à caractère personnel a un
        caractère réglementaire ou contractuel ou si elle conditionne la conclusion d'un contrat et si la personne concernée est tenue de fournir les données à
        caractère personnel, ainsi que sur les conséquences éventuelles de la non-fourniture de ces données, il est porté à la connaissance de l'Utilisateur les
        informations suivantes : (i) la demande de fourniture de données à caractère personnel a un caractère contractuel (dans le cadre de la cadre de la
        relation que l'Utilisateur souhaite nouer avec Infogreffe en lui passant une commande de prestations ou services ou Documents et/ou en utilisant les
        dites prestations) (ii) la fourniture de ces données, en ce qu'elle est nécessaire à la réalisation des prestations et/ou services commandés conditionne
        la conclusion de cette relation contractuelle (iii) à ce titre l'Utilisateur est tenu de communiquer ses données à caractère personnel s'il souhaite
        commander et/ou utiliser des prestations et/ou services et/ou Documents auprès d'Infogreffe et via le Site (iv) la non fourniture de ces données à
        caractère personnel ne permet pas de commander des prestations et/ou services et/ou Documents auprès d'Infogreffe.
      </div>
      <div class="subtitle">(k) Prise de décision automatisée</div>
      <div class="paragraph">
        Il est indiqué qu'il n'est pas procédé, au moyen des données à caractère personnel collectées, à une prise de décision automatisée au sens de la
        Réglementation en vigueur.
      </div>
      <div class="subtitle">(l) Eventuel traitement ultérieur des données à caractère personnel</div>
      <div class="paragraph">
        Dans le cas où il serait effectué un traitement ultérieur des données à caractère personnel pour les finalités autres que celles pour lesquelles les
        données à caractère personnel ont été collectées et telles qu'identifiées ci-avant, le responsable du traitement (identifié ci-avant) fournira au
        préalable à la personne concernée des informations au sujet de cette autre finalité et toute autre information pertinente légale requise.
      </div>
      <div class="title">AGE DE LA PERSONNE POUVANT FOURNIR SES DONNÉES À CARACTÈRE PERSONNEL</div>
      <div class="paragraph">
        Le recueil de données personnelles ne pouvant que concerner les personnes âgées d'au moins 15 ans, et les données personnelles étant, comme indiqué
        ci-avant, nécessaires à la réalisation et administration des prestations, services ou Documents commandés ou demandés via le Site, les personnes de
        moins de 15 (quinze) ans ne peuvent donner leur consentement au recueil de leurs données personnelles (et par voie de conséquence accéder aux
        prestations et services déployés via le Site) qu'à la condition d'être autorisées par le titulaire de la responsabilité parentale les concernant de
        sorte que, en sollicitant les prestations et/ou services accessibles via le Site et/ou en communiquant à Infogreffe des données à caractère personnel,
        les Utilisateurs déclarent et garantissent à Infogreffe qu'ils sont (i) soit âgés d'au moins 15 ans (ii) soit qu'ils sont autorisés par le titulaire de
        la responsabilité parentale les concernant. Cette stipulation est sans préjudice de l'engagement que souscrit l'Utilisateur vis-à-vis d'Infogreffe selon
        lequel il déclare et garantit à Infogreffe qu'il a la capacité juridique et légale d'utiliser les services et/ou prestations d'Infogreffe délivrés via
        le Site et, le cas échéant, de régler les dits services et/ou prestations.
      </div>
      <div class="title">MODIFICATIONS DES PRÉSENTES</div>
      <div class="paragraph">
        Les présentes pourront faire l'objet d'une actualisation. A ce titre, l'Utilisateur est invité à prendre connaissance de la dernière version des
        présentes, accessible sur le Site, notamment dans les CGU/CGV.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.container {
  margin: 96px 0;
  max-width: 987px;

  .main-title {
    font-weight: 500;
    font-size: 28px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: colors.$darkblue-color;
    margin-bottom: 24px;
  }

  .title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;

    display: flex;
    align-items: center;

    color: colors.$text-color;

    margin-bottom: 12px;
  }

  .subtitle {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .paragraph {
    margin-bottom: 24px;
  }

  .link {
    color: colors.$main-color;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
